import { get } from "lodash";
import { useEffect, useReducer, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  IMetaItemDynamoDb,
  ItemArea,
  ItemCity,
  ItemZone,
  TagInputSearch,
  TagInputSearchEnum,
} from "src/interfaces";
import { RootState } from "src/store";
import {
  QUERY_STRING_BENIFIT,
  QUERY_STRING_HOTEL_INFO_PET,
  QUERY_STRING_HOTEL_INFO_SPECIAL,
  QUERY_STRING_LATE_CHECKOUT,
  QUERY_STRING_ROOM_BATH_TYPE,
  QUERY_STRING_ROOM_BED_TYPE,
  QUERY_STRING_ROOM_SPRING_TYPE,
  QUERY_STRING_ROOM_TYPE,
  QUERY_STRING_SEARCH_AREA_ID,
  QUERY_STRING_SEARCH_CITY_ID,
  // QUERY_STRING_SEARCH_HOTEL_AMENITY,
  QUERY_STRING_SEARCH_HOTEL_EVALUTION,
  QUERY_STRING_SEARCH_HOTEL_HOT_SPOT,
  QUERY_STRING_SEARCH_HOTEL_STATION,
  QUERY_STRING_SEARCH_HOTEL_TYPE,
  QUERY_STRING_SEARCH_NUMBER_ADULT,
  QUERY_STRING_SEARCH_NUMBER_ROOM,
  QUERY_STRING_SEARCH_THEME,
  QUERY_STRING_SEARCH_ZONE_ID,
  QUERY_STRING_SERVICE_TYPE,
  QUERY_STRING_VIEW_TYPE,
  QUERY_STRING_SEARCH_BUDGET_FROM,
  QUERY_STRING_SEARCH_BUDGET_TO,
  QUERY_STRING_ROOM_ROOM_STYLE,
  QUERY_STRING_ROOM_SMOKING_TYPE,
  QUERY_STRING_ROOM_AMENITY,
  QUERY_STRING_HOTEL_INFO_FACILITY,
  QUERY_STRING_METHOD_PAYMENT_SUPPORT,
} from "src/interfaces/defineQueryStringProperties";
import { formatPrice } from "./format-price";
import { insertUrlParam, removeUrlParameter } from "./urlQueryHandle";

const getBudgetLabel = (type: string, value: string, t: any) => {
  if (type === QUERY_STRING_SEARCH_BUDGET_FROM) {
    return `${formatPrice(Number(value))}${t("common.money.unit")}～`;
  } else return `～${formatPrice(Number(value))}円`;
};

const NafutelQueryString = () => {
  const { t } = useTranslation();
  const { data } = useSelector((state: RootState) => state.metadata);
  
  const params = new URLSearchParams(window.location.search);
  let initValue: any = Object.fromEntries(params.entries()) || {};
  if (!initValue[QUERY_STRING_SEARCH_NUMBER_ADULT]) {
    initValue[QUERY_STRING_SEARCH_NUMBER_ADULT] = 2;
  }
  if (!initValue[QUERY_STRING_SEARCH_NUMBER_ROOM]) {
    initValue[QUERY_STRING_SEARCH_NUMBER_ROOM] = 1;
  }
  const [query, setQuery] = useState(initValue);
  const [tags, setTags] = useState<TagInputSearch[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    let newtags: TagInputSearch[] = [];

    function remapTags(
      key_param: string,
      key_data: string,
      type: TagInputSearchEnum
    ) {
      if (
        key_param === QUERY_STRING_SEARCH_BUDGET_FROM ||
        key_param === QUERY_STRING_SEARCH_BUDGET_TO
      ) {
        newtags.push({
          id: QUERY_STRING_SEARCH_BUDGET_FROM,
          label: getBudgetLabel(key_param, query[key_param], t),
          type,
        });
        return;
      }
      const ids = query[key_param].split(",") || [];
      ids.forEach((id: string) => {
        const ex: ItemZone | ItemArea | ItemCity | IMetaItemDynamoDb = get(
          data,
          `${key_data}.${id}`
        );
        if (ex) {
          newtags.push({
            id: id,
            label: ex.text_value,
            type,
            metadata: { ...ex },
          });
        }
      });
    }

    if (query[QUERY_STRING_SEARCH_ZONE_ID]) {
      remapTags(
        QUERY_STRING_SEARCH_ZONE_ID,
        "zone_obj",
        TagInputSearchEnum.ZONE
      );
    }

    if (query[QUERY_STRING_SEARCH_AREA_ID]) {
      remapTags(
        QUERY_STRING_SEARCH_AREA_ID,
        "area_obj",
        TagInputSearchEnum.AREA
      );
    }
    if (query[QUERY_STRING_SEARCH_CITY_ID]) {
      remapTags(
        QUERY_STRING_SEARCH_CITY_ID,
        "city_obj",
        TagInputSearchEnum.CITY
      );
    }

    if (query[QUERY_STRING_SEARCH_HOTEL_STATION]) {
      remapTags(
        QUERY_STRING_SEARCH_HOTEL_STATION,
        "station_obj",
        TagInputSearchEnum.STATION
      );
    }

    if (query[QUERY_STRING_SEARCH_HOTEL_HOT_SPOT]) {
      remapTags(
        QUERY_STRING_SEARCH_HOTEL_HOT_SPOT,
        "spots_obj",
        TagInputSearchEnum.SPOTS
      );
    }
    
    if (query[QUERY_STRING_ROOM_AMENITY]) {
      remapTags(
        QUERY_STRING_ROOM_AMENITY,
        "amenity_obj",
        TagInputSearchEnum.AMENITY
      );
    }
    if (query[QUERY_STRING_HOTEL_INFO_FACILITY]) {
      remapTags(
        QUERY_STRING_HOTEL_INFO_FACILITY,
        "hotel_info_facility_obj",
        TagInputSearchEnum.FACILITY
      );
    }
    if (query[QUERY_STRING_METHOD_PAYMENT_SUPPORT]) {
      remapTags(
        QUERY_STRING_METHOD_PAYMENT_SUPPORT,
        "method_payment_support_obj",
        TagInputSearchEnum.METHOD_PAYMENT_SUPPORT
      );
    }
    if (query[QUERY_STRING_SEARCH_HOTEL_TYPE]) {
      remapTags(
        QUERY_STRING_SEARCH_HOTEL_TYPE,
        "hotel_type_obj",
        TagInputSearchEnum.HOTEL_TYPE
      );
    }
    if (query[QUERY_STRING_ROOM_TYPE]) {
      remapTags(
        QUERY_STRING_ROOM_TYPE,
        "room_type_obj",
        TagInputSearchEnum.ROOM_TYPE
      );
    }
    if (query[QUERY_STRING_ROOM_BED_TYPE]) {
      remapTags(
        QUERY_STRING_ROOM_BED_TYPE,
        "bed_type_obj",
        TagInputSearchEnum.ROOM_BED_TYPE
      );
    }
    if (query[QUERY_STRING_ROOM_SPRING_TYPE]) {
      remapTags(
        QUERY_STRING_ROOM_SPRING_TYPE,
        "spring_type_obj",
        TagInputSearchEnum.ROOM_SPRING_TYPE
      );
    }
    if (query[QUERY_STRING_ROOM_BATH_TYPE]) {
      remapTags(
        QUERY_STRING_ROOM_BATH_TYPE,
        "bath_type_obj",
        TagInputSearchEnum.ROOM_BATH_TYPE
      );
    }
    if (query[QUERY_STRING_SEARCH_THEME]) {
      remapTags(
        QUERY_STRING_SEARCH_THEME,
        "hotel_theme_obj",
        TagInputSearchEnum.HOTEL_THEME
      );
    }
    if (query[QUERY_STRING_SERVICE_TYPE]) {
      remapTags(
        QUERY_STRING_SERVICE_TYPE,
        "service_obj",
        TagInputSearchEnum.SERVICE_TYPE
      );
    }
    if (query[QUERY_STRING_VIEW_TYPE]) {
      remapTags(
        QUERY_STRING_VIEW_TYPE,
        "view_obj",
        TagInputSearchEnum.VIEW_TYPE
      );
    }
    if (query[QUERY_STRING_LATE_CHECKOUT]) {
      remapTags(
        QUERY_STRING_LATE_CHECKOUT,
        "late_checkout_obj",
        TagInputSearchEnum.LATE_CHECKOUT
      );
    }
    if (query[QUERY_STRING_BENIFIT]) {
      remapTags(
        QUERY_STRING_BENIFIT,
        "benifit_obj",
        TagInputSearchEnum.BENIFIT
      );
    }
    if (query[QUERY_STRING_SEARCH_HOTEL_EVALUTION]) {
      remapTags(
        QUERY_STRING_SEARCH_HOTEL_EVALUTION,
        "evalution_obj",
        TagInputSearchEnum.EVALUTION
      );
    }
    if (query[QUERY_STRING_HOTEL_INFO_PET]) {
      remapTags(
        QUERY_STRING_HOTEL_INFO_PET,
        "hotel_info_pet_obj",
        TagInputSearchEnum.INFO_PET
      );
    }
    if (query[QUERY_STRING_HOTEL_INFO_SPECIAL]) {
      remapTags(
        QUERY_STRING_HOTEL_INFO_SPECIAL,
        "hotel_info_special_obj",
        TagInputSearchEnum.INFO_SPECIAL
      );
    }

    if (query[QUERY_STRING_SEARCH_BUDGET_FROM]) {
      remapTags(
        QUERY_STRING_SEARCH_BUDGET_FROM,
        "budget_from",
        TagInputSearchEnum.BUDGET_FROM
      );
    }

    if (query[QUERY_STRING_SEARCH_BUDGET_TO]) {
      remapTags(
        QUERY_STRING_SEARCH_BUDGET_TO,
        "budget_to",
        TagInputSearchEnum.BUDGET_TO
      );
    }

    if (query[QUERY_STRING_ROOM_ROOM_STYLE]) {
      remapTags(
        QUERY_STRING_ROOM_ROOM_STYLE,
        "room_style_obj",
        TagInputSearchEnum.ROOM_STYLE
      );
    }

    if (query[QUERY_STRING_ROOM_SMOKING_TYPE]) {
      remapTags(
        QUERY_STRING_ROOM_SMOKING_TYPE,
        "smoking_type_obj",
        TagInputSearchEnum.SMOKING_TYPE
      );
    }

    setTags(newtags);
  }, [query, data, t]);

  const pushQuery: any = (key: string, newValue: string, isAddUrl = true) => {
    const p = new URLSearchParams(window.location.search);
    const dataObj: any = {
      ...(Object.fromEntries(p.entries()) || {}),
      [key]: newValue,
    };
    if (!dataObj[QUERY_STRING_SEARCH_NUMBER_ADULT]) {
      dataObj[QUERY_STRING_SEARCH_NUMBER_ADULT] = 2;
      insertUrlParam(QUERY_STRING_SEARCH_NUMBER_ADULT, "2");
    }
    setQuery(dataObj);
    if (isAddUrl) {
      insertUrlParam(key, newValue);
    }
  };

  const pushMutilQuery: any = (keys: [{ key: string; value: any }]) => {
    const data: any = {};
    keys.forEach((item) => {
      data[item.key] = item.value;
      insertUrlParam(item.key, item.value);
    });
    const p = new URLSearchParams(window.location.search);
    setQuery({
      ...(Object.fromEntries(p.entries()) || {}),
      ...data,
    });
  };

  const removeQuery: any = (key: string) => {
    let newQs = { ...query };
    delete newQs[key];
    setQuery({ ...newQs });
    removeUrlParameter(key);
  };

  const removeMutilQuery: any = (keys: string[]) => {
    let newQs = { ...query };
    keys.forEach((key) => {
      delete newQs[key];
      removeUrlParameter(key);
    });
    setQuery({ ...newQs });
  };

  const forceUpdateQuery = () => {
    const p = new URLSearchParams(window.location.search);
    setQuery({
      ...(Object.fromEntries(p.entries()) || {}),
    });
    forceUpdate();
  };

  return [
    tags,
    query,
    pushQuery,
    pushMutilQuery,
    removeQuery,
    removeMutilQuery,
    forceUpdateQuery,
  ];
};

export default NafutelQueryString;
